"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCOUNT_NAME_MAX_LENGTH = exports.ACCOUNT_NAME = void 0;
var ACCOUNT_NAME = 'accountName';
exports.ACCOUNT_NAME = ACCOUNT_NAME;
var ACCOUNT_NAME_MAX_LENGTH = 25;
exports.ACCOUNT_NAME_MAX_LENGTH = ACCOUNT_NAME_MAX_LENGTH;